import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private url: string = environment.url;
  public user: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public token: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  permissons: any[] = [];

  constructor(
    private http: HttpClient,
    private router: Router
  ) {
    this.setValue();
  }

  setValue() {
    const user = JSON.parse(localStorage.getItem('user'));
    this.token.next(localStorage.getItem('token'));
    if (user) {
      this.user.next(user);
    }
  }

  public get userValue() {
    return this.user.value;
  }

  getAllClientes(slug: string) {
    return this.http.get(`${this.url}/api/clientes`, {
      headers: {
        'tenant-id': slug.toString()
      }
    });
  }


  getAll() {
    return this.http.get(`${this.url}/api/users`);
  }

  getAllTenants() {
    return this.http.get(`${this.url}/api/tenants`);
  }

  getAllUsuarioTenants() {
    return this.http.get(`${this.url}/api/usuariostenants`);
  }

  getId(id) {
    return this.http.get(`${this.url}/api/users/${id}`).pipe(
      map((response: any) => {
        return response.user;
      })
    );
  }
  //
  create(user: FormData) {
    return this.http.post(`${this.url}/api/users`, user);
  }

  edit(id: number, user: FormData) {
    return this.http.post(`${this.url}/api/users/${id}`, user).pipe(
      map((response: any) => {
        const userStorage = JSON.parse(localStorage.getItem('user') || '{}');

        if (response?.user && userStorage && response.user.id === userStorage.id) {
          userStorage.name = response.user.name;
          userStorage.email = response.user.email;
          localStorage.setItem('user', JSON.stringify(userStorage));
          this.user.next(userStorage);
        }

        return response; // Devuelve la respuesta para que `subscribe` la reciba
      })
    );
  }

  profile(user: any) {
    return this.http.post(`${this.url}/api/auth/refresh?_method=PUT`, user).pipe(
      tap((response: any) => {
        localStorage.setItem('user', JSON.stringify(response.user));
        this.user.next(response.user);
      })
    );
  }

  delete(id) {
    return this.http.delete(`${this.url}/api/users/${id}`);
  }

  login(user) {
    return this.http.post(`${this.url}/api/auth/login`, user).pipe(
      tap((response: any) => {
        localStorage.setItem('user', JSON.stringify(response.user));
        localStorage.setItem('token', response.token);
        this.token.next(response.token);
        this.user.next(response.user);
      })
    );
  }

  logout() {
    // this.http.post(`${this.url}/api/auth/logout`, null).subscribe({
    //   next: (response: any) => {
    //     if (response.code === 200) {
          localStorage.clear();
          this.token.next(null);
          this.user.next(null);
          this.router.navigate(['/auth/login']);
        // }
    //   },
    //   error: (error) => {
    //     console.error('Error en logout', error);
    //   }
    // });
  }

  public updateAuthUser(updatedUser: any): void {
    const userStorage = JSON.parse(localStorage.getItem('user') || '{}');

    const newUser = { ...userStorage, ...updatedUser };

    localStorage.setItem('user', JSON.stringify(newUser));
    this.user.next(newUser);
  }


  isPermit(slug: string): boolean {
    const user = this.user.value;

    if (!user || !Array.isArray(user.permissions)) {
      return true;
    }

    const permissions = user.permissions.map(p => p.slug);
    return permissions.includes(slug);
  }


  industryList() {
    return this.http.get(`${this.url}/api/industry`).pipe(
      map(res => {
        return res['industry'];
      })
    );
  }

  editIndustry(id, data) {
    return this.http.put(`${this.url}/api/industry/${id}`, data);
  }

  deleteIndustry(id) {
    return this.http.delete(`${this.url}/api/industry/${id}`);
  }

  createIndustry(data) {
    return this.http.post(`${this.url}/api/industry`, data);
  }

  sizeList() {
    return this.http.get(`${this.url}/api/team-size`).pipe(
      map(res => {
        return res['teamSize'];
      })
    );
  }

  editTeamSize(id, data) {
    return this.http.put(`${this.url}/api/team-size/${id}`, data);
  }

  deleteTeamSize(id) {
    return this.http.delete(`${this.url}/api/team-size/${id}`);
  }

  createTeamSize(data) {
    return this.http.post(`${this.url}/api/team-size`, data);
  }

  getPermissions() {
    return this.http.get(`${this.url}/api/permissions`);
  }

  getRoles(slug: string) {
    return this.http.get(`${this.url}/api/roles`, {
      headers: {
        'tenant-id': slug.toString()
      }
    });
  }

  getRoleId(id) {
    return this.http.get(`${this.url}/api/roles/${id}`).pipe(
      map((response: any) => {
        return response.role;
      })
    );
  }

  createRole(role) {
    return this.http.post(`${this.url}/api/roles`, role);
  }

  updateRole(role) {
    return this.http.put(`${this.url}/api/roles/${role.id}`, role);
  }

  deleteRole(id) {
    return this.http.delete(`${this.url}/api/roles/${id}`);
  }

  userActiveSelect() {
    return this.http.get(`${this.url}/api/users/data/userActiveSelect`);
  }

  userTenants() {
    return this.http.get(`${this.url}/api/users/data/userTenants`);
  }

  loginWithProvider(provider: 'google'): Promise<{ user: any, token?: string, is_new: boolean }> {
    return new Promise((resolve, reject) => {
      const authWindow = window.open(
          `${this.url}/api/auth/loginSocial/${provider}/redirect`,
          '_blank',
          'width=600,height=700'
      );

      const listener = (event: MessageEvent) => {
        if (event.data?.status === 'success') {
            const { user, token, is_new } = event.data;

            if (is_new) {
                // Caso nuevo usuario:
                console.log("ingreso a nuevo usuario")
                window.removeEventListener('message', listener);
                authWindow?.close();
                resolve({ user, is_new, token: null });
            } else {
                // Caso usuario existente:
                console.log("Usuario exitente")
                localStorage.setItem('user', JSON.stringify(event.data.user));
                localStorage.setItem('token', event.data.token);
                this.token.next(event.data.token);
                this.user.next(event.data.user);
                window.removeEventListener('message', listener);
                authWindow?.close();
                resolve({ user, token, is_new });
            }
        } else if (event.data?.status === 'error') {
            window.removeEventListener('message', listener);
            authWindow?.close();
            reject(event.data);
        }
      };

      window.addEventListener('message', listener);
    });
  }
}
